var map = {
	".": "jv/w",
	"./": "jv/w",
	"./email": "Zmx8",
	"./email.js": "Zmx8",
	"./index": "jv/w",
	"./index.js": "jv/w",
	"./phone": "ASOO",
	"./phone.js": "ASOO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5Zm3";